import { CompanyCertificationType } from "@/graphql/codegen/graphql"

export const CompanyCertificationTypeLabelMap = new Map<CompanyCertificationType, string>([
  [CompanyCertificationType.Iso_9001, "ISO 9001"],
  [CompanyCertificationType.Iso_14001, "ISO 14001"],
  [CompanyCertificationType.Iso_45001, "ISO 45001"],
  [CompanyCertificationType.Iso_27001, "ISO 27001"],
  [CompanyCertificationType.Iso_50001, "ISO 50001"],
  [CompanyCertificationType.Nacd, "NACD"],
  [CompanyCertificationType.Ecovadis, "Ecovadis"],
  [CompanyCertificationType.CustomerServiceSurvey, "Customer Service Survey"],
  [CompanyCertificationType.Osha_45001, "OSHA 45001"],
])
